// extracted by mini-css-extract-plugin
export var errorIcon = "_on-1";
export var nameLogo = "_on-0";